import { useReducer } from "react";
import { ScoreAction, ScoreData } from "../Score";
import { defaultScoreData } from "../ScoreDatas";

export const useScoreReducer = () => {
  const [data, dispatch] = useReducer(
    (data: ScoreData, action: ScoreAction): ScoreData => {
      switch (action.type) {
        case "completePOI":
          const chapterId = action.poiId.split(".")[0];
          const chapterIndex = data.chapters.findIndex(
            (chapter) => chapter.id === chapterId
          );

          if (chapterIndex !== -1) {
            const chapter = { ...data.chapters[chapterIndex] };
            if (!chapter.poisDone.includes(action.poiId)) {
              chapter.poisDone.push(action.poiId);
              chapter.progression = chapter.poisDone.length / chapter.poisCount;
              chapter.isDone = chapter.poisDone.length === chapter.poisCount;
              data.chapters[chapterIndex] = { ...chapter };
            }

            //  check unlocked
            data.chapters.map((chapter, i) => {
              data.chapters[i].isLocked = chapter.blockBy.reduce(
                (isLocked, blocker) => {
                  data.chapters.map((c) => {
                    if (c.id === blocker && !c.isDone) isLocked = true;
                    return "";
                  });
                  return isLocked;
                },
                false
              );
              return "";
            });

            //  update main progress
            data.progression =
              data.chapters.reduce(
                (prog, chapter) => prog + chapter.progression,
                0
              ) / data.chapters.length;
          }

          return { ...data, chapters: [...data.chapters] };
        case "unlockAllChapter":
          return {
            ...data,
            chapters: data.chapters.map((chapter) => ({
              ...chapter,
              isLocked: false,
              isDone: true,
            })),
          };
        default:
          return { ...data, chapters: [...data.chapters] };
      }
    },
    defaultScoreData
  );

  return { data, dispatch };
};
